module.exports = __webpack_public_path__ + "img/empty-data.276c05f0.png";